import React from "react";

function HighlightText(props) {
  return (
    <p className={props.className}>
      {props.text1 + " "}{" "}
      {!props.hasHyperLink && (
        <span className={props.subClassName}>{props.subText}</span>
      )}
      {props.hasHyperLink && (
        <a
          className={props.subClassName}
          href={props.hyperLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          {props.subText}
        </a>
      )}
      {" " + props.text2}
    </p>
  );
}

export default HighlightText;
